"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelPageHighchartsOptionsProvider = void 0;
const React = __importStar(require("react"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const FunnelPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageDataProvider");
const FunnelPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelPageModelProvider");
const lodash_1 = __importDefault(require("lodash"));
const FunnelJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/model/FunnelJSONModel");
const FunnelPageHighchartsOptionsProvider = (props) => {
    const pageDataContext = (0, FunnelPageDataProvider_1.useFunnelPageDataContext)();
    const pageModelContext = (0, FunnelPageModelProvider_1.useFunnelPageModelContext)();
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const chartType = urlJSONModel.getChartSettingsJSONModel().getChartType();
    const formModelSerialized = pageModelContext.pageModelStateFns.getFormJSONModel().serialize();
    const urlModelSerialized = urlJSONModel.serialize();
    const highchartsChartStatus = calculateHighchartsChartStatus(formModelSerialized, urlModelSerialized);
    return React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: pageDataContext.state.error, data: pageDataContext.state.data, parameters: {
            chartType: chartType,
        }, highchartsOptionsProviderFn: ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getFunnel, chartStatus: highchartsChartStatus }, props.children);
};
exports.FunnelPageHighchartsOptionsProvider = FunnelPageHighchartsOptionsProvider;
const calculateHighchartsChartStatus = (formModel, urlModel) => {
    formModel = FunnelJSONModel_1.FunnelJSONModel.makeModelStateClean(formModel);
    urlModel = FunnelJSONModel_1.FunnelJSONModel.makeModelStateClean(urlModel);
    const formModelEmpty = FunnelJSONModel_1.FunnelJSONModel.isModelEmpty(formModel);
    const urlModelEmpty = FunnelJSONModel_1.FunnelJSONModel.isModelEmpty(urlModel);
    if (urlModelEmpty) {
        // if (formModelEmpty) {
        return { status: "notLoaded" };
        // } else {
        //     return {status: "parametersChanged"}
        // }
    }
    else {
        const formModelEqualsToURLModel = lodash_1.default.isEqual(formModel, urlModel);
        if (formModelEqualsToURLModel) {
            return { status: "loaded" };
        }
        if (formModelEmpty) {
            return { status: "parametersChangedButEmpty" };
        }
        else {
            return { status: "parametersChanged" };
        }
    }
};
